import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import { alertSx, helperTextSx, primaryButtonSx, textFieldSx } from './authFormStyles';

interface Props {
  onSubmit: (newPassword: string) => void;
  loading: boolean;
  error: string | null;
}

const MIN_PASSWORD_LENGTH = 8;

export const NewPasswordRequiredForm: React.FC<Props> = ({ onSubmit, loading, error }) => {
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');

  const lengthOk = pw1.length >= MIN_PASSWORD_LENGTH;
  const matchOk = pw2.length > 0 && pw1 === pw2;
  const canSubmit = lengthOk && matchOk && !loading;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    onSubmit(pw1);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}
    >
      <Box component="div" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <Box
          component="div"
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, rgba(199, 20, 68, 0.18) 0%, rgba(199, 20, 68, 0.08) 100%)',
            border: '1px solid rgba(199, 20, 68, 0.32)',
          }}
        >
          <VpnKeyOutlinedIcon sx={{ color: '#C71444', fontSize: 28 }} />
        </Box>
        <Typography
          variant="h6"
          sx={{ color: 'rgba(255, 255, 255, 0.95)', fontWeight: 500, letterSpacing: '0.02em' }}
        >
          パスワードを設定
        </Typography>
        <Typography variant="body2" sx={{ ...helperTextSx, textAlign: 'center', mt: 0.5 }}>
          初回ログインのため、新しいパスワードを設定してください
        </Typography>
      </Box>

      <TextField
        label="新しいパスワード"
        type="password"
        value={pw1}
        onChange={(e) => setPw1(e.target.value)}
        autoComplete="new-password"
        autoFocus
        helperText={`${MIN_PASSWORD_LENGTH} 文字以上`}
        error={pw1.length > 0 && !lengthOk}
        fullWidth
        sx={textFieldSx}
      />
      <TextField
        label="新しいパスワード（確認）"
        type="password"
        value={pw2}
        onChange={(e) => setPw2(e.target.value)}
        autoComplete="new-password"
        error={pw2.length > 0 && pw1 !== pw2}
        helperText={pw2.length > 0 && pw1 !== pw2 ? 'パスワードが一致しません' : ' '}
        fullWidth
        sx={textFieldSx}
      />
      {error && (
        <Alert severity="error" sx={alertSx}>
          {error}
        </Alert>
      )}
      <Button
        type="submit"
        variant="contained"
        disabled={!canSubmit}
        startIcon={loading ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : undefined}
        sx={primaryButtonSx}
        fullWidth
      >
        パスワードを設定
      </Button>
    </Box>
  );
};
